<script lang="ts" setup>
import * as yup from 'yup'
import * as PrimeVue from 'primevue'
import type { DynamicFormInstance } from '~/components/DynamicForm'
import type { DynamicFormFieldInstance } from '~/components/DynamicFormField'
import * as Fields from '~/components/fields'

const field = ref<Element>()
const props = defineProps<{
  as: string
  schema: yup.Schema
}>()

const $fcDynamicForm = inject<DynamicFormInstance | undefined>(
  '$fcDynamicForm',
  undefined
)
const $fcDynamicFormField = inject<DynamicFormFieldInstance | undefined>(
  '$fcDynamicFormField',
  undefined
)

const id = computed<string>(() => `id_${$fcDynamicFormField?.name}`)
const name = computed<string>(() =>
  $fcDynamicFormField ? $fcDynamicFormField.name : ''
)
// @ts-ignore
const component = computed(() => PrimeVue[props.as] ?? Fields[props.as])
const componentId = computed(() => {
  if (
    component.value?.extends?.props &&
    'inputId' in component.value.extends.props
  )
    return { inputId: id.value }
  return { id: id.value }
})

const getField = () => field.value

$fcDynamicForm?.addField(name.value, props.schema)

onMounted(() => {
  $fcDynamicForm?.addFormField(name.value, field.value)
})

defineExpose({ getField })
</script>

<template>
  <component
    v-bind="componentId"
    :is="component"
    :name="name"
    fluid
    ref="field"
  />
</template>
